import {useEffect} from 'react'

export const useBodyClass = (conditional, className) => {
  useEffect(() => {
    document.body.classList[conditional ? 'add' : 'remove'](className)
  }, [conditional])
}
